import { render, staticRenderFns } from "./DashboardDossierQualification.vue?vue&type=template&id=2063e438"
import script from "./DashboardDossierQualification.vue?vue&type=script&lang=js"
export * from "./DashboardDossierQualification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports